import { render, staticRenderFns } from "./IpsDatePicker.vue?vue&type=template&id=45f7bfe7"
import script from "./IpsDatePicker.vue?vue&type=script&lang=js"
export * from "./IpsDatePicker.vue?vue&type=script&lang=js"
import style0 from "./IpsDatePicker.vue?vue&type=style&index=0&id=45f7bfe7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports